import axios from 'axios';
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const api = axios.create({ baseURL: API_URL });

function getGhostMode() {
  try { return JSON.parse(localStorage.getItem('ghost_mode') || 'null'); } catch { return null; }
}

api.interceptors.request.use(config => {
  const ghost = getGhostMode();
  const token = (ghost?.active && ghost?.token) ? ghost.token : localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  response => response,
  async error => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retry) {
      original._retry = true;
      // In ghost mode: token expired → just clear ghost and close tab
      const ghost = getGhostMode();
      if (ghost?.active) {
        localStorage.removeItem('ghost_mode');
        alert('Ghost session expired.');
        window.close();
        setTimeout(() => { window.location.href = '/login'; }, 300);
        return Promise.reject(error);
      }
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        try {
          const res = await axios.post(`${API_URL}/auth/refresh`, {}, {
            headers: { Authorization: `Bearer ${refreshToken}` }
          });
          const newToken = res.data.access_token;
          localStorage.setItem('token', newToken);
          original.headers.Authorization = `Bearer ${newToken}`;
          return api(original);
        } catch {
          localStorage.removeItem('token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);
export default api;
